var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { connect } from "react-redux";
import { addToBasket, emptyBasket, updateCinemaLocation } from "@irati/deals/store/actions/Product";
import ErrorText from "@irati/ui/src/ErrorText";
import Loading from "@irati/ui/src/Loading";
import { injectIntl } from "@irati/utils/lang";
import { COMPANY_BENEFITS as DEAL_TYPE_COMPANY_BENEFITS } from "@irati/deals/constants/dealType";
import tracking from "@irati-tracking/perks/perks";
import getMessage from "@irati/utils/lang/helpers/getMessage";
import redemptionUtils from "../../helpers/redemption/redemptionUtils";
import ImportantInfoBlock from "../../components/ImportantInfoBlock";
import InlineImportantInfoBlock from "../../components/ImportantInfoBlock/InlineImportantInfoBlock";
import getNetworkCatchErrorDetails from "../../utils/getNetworkCatchErrorDetails";
var DealImportantInfoContainer = /** @class */ (function (_super) {
    __extends(DealImportantInfoContainer, _super);
    function DealImportantInfoContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onPostError = function (error) {
            var errorMessage = getNetworkCatchErrorDetails(error);
            errorMessage.errorData = error.errorData;
            _this.setState({
                submit: null,
                errorMessage: errorMessage
            });
        };
        _this.startSaga = function () {
            var _a = _this.props, deal = _a.deal, user = _a.user;
            tracking.startRedeemPerk(deal);
            var details = {
                user: user.uuid,
                deal: deal.uuid
            };
            var submit = redemptionUtils
                .nextStep(null, deal, details)
                .then(function (updatedSaga) {
                var pathname = redemptionUtils.currentStep(updatedSaga, deal);
                return { pathname: pathname, state: { deal: deal, saga: updatedSaga } };
            })
                .catch(_this.onPostError);
            _this.setState({ submit: submit });
            return submit;
        };
        _this.state = {
            submit: null,
            errorMessage: null
        };
        return _this;
    }
    DealImportantInfoContainer.prototype.componentDidMount = function () {
        this.props.emptyBasket();
    };
    DealImportantInfoContainer.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.deal !== this.props.deal) {
            this.setState({ errorMessage: null });
        }
    };
    DealImportantInfoContainer.prototype.render = function () {
        var _this = this;
        var _a = this.state, submit = _a.submit, errorMessage = _a.errorMessage;
        var _b = this.props, deal = _b.deal, formatMessage = _b.formatMessage, isInline = _b.isInline;
        var importantInfo = deal.importantInfo, termsAndConditions = deal.termsAndConditions;
        var userSavings = deal.savings.userSavings;
        var isCompanyBenefit = deal.type === DEAL_TYPE_COMPANY_BENEFITS;
        var initialButtonText = isCompanyBenefit
            ? formatMessage({ id: "perks.containers.dealImportantInfo.getBenefit" })
            : formatMessage({ id: "perks.containers.dealImportantInfo.getPerk" });
        var buttonText = submit ? formatMessage({ id: "perks.containers.dealImportantInfo.button" }) : initialButtonText;
        var InfoBlock = isInline ? InlineImportantInfoBlock : ImportantInfoBlock;
        return (React.createElement(React.Fragment, null,
            React.createElement(InfoBlock, { onClick: function () { return _this.startSaga(); }, deal: deal, importantListData: importantInfo, termsAndConditions: termsAndConditions, userSavings: userSavings, buttonText: buttonText, buttonDisabled: submit, collapseBlock: this.props.collapseBlock, submit: submit }),
            React.createElement(Loading, { load: submit, useLoader: false }),
            errorMessage && React.createElement(ErrorText, null, getMessage(formatMessage, errorMessage.message, errorMessage.errorData))));
    };
    DealImportantInfoContainer.defaultProps = {
        collapseBlock: false,
        isInline: false
    };
    return DealImportantInfoContainer;
}(Component));
var mapDispatchToProps = function (dispatch) {
    return {
        addToBasket: function (uuid) { return dispatch(addToBasket(uuid)); },
        emptyBasket: function () {
            dispatch(emptyBasket());
            dispatch(updateCinemaLocation(""));
        }
    };
};
export default injectIntl(connect(null, mapDispatchToProps)(DealImportantInfoContainer));
